<div [class]="_computedClass()">
  <span>{{ label() }}</span>
  @if (estVerrouille()) {
    <ng-icon name="lucideLockKeyhole" hlm size="sm" />
  } @else {
    <ng-icon name="lucideLockKeyholeOpen" hlm size="sm" />
  }
</div>
